import { Box } from '../../../../../base';
import RequirementItem from './RequirementItem';
import {
    ISaveJobRequirement,
    ISaveJobForm,
    SAVE_JOB_FORM_VALUES,
} from '../../../../../common';
import { UseFieldArrayReturn, useFormContext } from 'react-hook-form';
import { GroupTitle, GroupWrap } from './RequirementsList.styles';

interface Props {
    requirementsArray: UseFieldArrayReturn<
        ISaveJobForm,
        SAVE_JOB_FORM_VALUES.JOB_REQUIREMENTS,
        'requirementId'
    >;
}

const RequirementsList = ({ requirementsArray }: Props) => {
    const methods = useFormContext<ISaveJobForm>();

    const groupedRequirements =
        requirementsArray.fields?.reduce(
            (acc, requirement, index) => {
                const group = requirement.requirementGroup || '';
                if (!acc[group]) {
                    acc[group] = [];
                }
                acc[group].push({ ...requirement, requirementIndex: index });
                return acc;
            },
            {} as Record<string, ISaveJobRequirement[]>
        ) || {};

    const onUpdateRequirement = (index: number) => {
        const updatedRequirement = methods.getValues(
            `${SAVE_JOB_FORM_VALUES.JOB_REQUIREMENTS}.${index}`
        );
        requirementsArray.update(index, updatedRequirement);
    };

    const onDeleteRequirement = (index: number) => {
        requirementsArray.remove(index);
    };

    const renderGroupedRequirements = () =>
        Object.entries(groupedRequirements)?.map(([group, reqs]) => (
            <Box key={group}>
                <GroupTitle variant="h6">{group}</GroupTitle>
                <GroupWrap>
                    {reqs.map((req, index) => (
                        <RequirementItem
                            key={Date.now() + index}
                            requirement={req}
                            onDelete={() =>
                                onDeleteRequirement(req.requirementIndex || 0)
                            }
                            onUpdateRequirement={() =>
                                onUpdateRequirement(req.requirementIndex || 0)
                            }
                            requirementIndex={req.requirementIndex || 0}
                            isFirstItem={index === 0}
                        />
                    ))}
                </GroupWrap>
            </Box>
        ));

    return <Box>{renderGroupedRequirements()}</Box>;
};

export default RequirementsList;
